import { useCookie } from '#imports'

const COOKIE_NAME = 'homeToGo'
const COOKIE_VALUE = 1

export const hometogoCookie = () => {
  const runtimeConfig = useRuntimeConfig()

  const cookie = useCookie<number | null>(COOKIE_NAME, {
    domain: runtimeConfig.public.COOKIE_DOMAIN_HOME_TO_GO,
    path: '/',
  })

  const isHomeToGoCookieSet = () => {
    return cookie.value === COOKIE_VALUE
  }

  const setHomeToGoCookie = () => {
    cookie.value = COOKIE_VALUE
  }

  return {
    isHomeToGoCookieSet,
    setHomeToGoCookie,
  }
}
